"use client";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import {
    useLanguage,
} from "@/components/LanguageContext";

const translations = {
    hu: {
        monsterAlt:
            "Feed the Beast szörny",

        introTitleFirst:
            "csak a legjobb játékosok",

        introTitleSecond:
            "juthatnak be ide",

        introText:
            "gyűjtsd a pontokat a strike zone pályáin, nyisd meg a bónuszjátékot, és szerezd meg az aznapi fődíjat.",

        howItWorks:
            "hogyan működik?",

        steps: [
            {
                number: "01",
                text:
                    "érd el az 1500 pontot a strike zone pályáin.",
            },
            {
                number: "02",
                text:
                    "találd el a szörnyet az aranynyíllal.",
            },
            {
                number: "03",
                text:
                    "etesd meg a szörnyet, és nyerd meg az aznapi fődíjat.",
            },
        ],

        prizeTitle:
            "szerezd meg a fődíjat",

        prizeIconsAlt:
            "Feed the Beast nyeremény ikonok",

        gameImageAlt:
            "Feed the Beast pálya",
    },

    en: {
        monsterAlt:
            "Feed the Beast monster",

        introTitleFirst:
            "only the best players",

        introTitleSecond:
            "can enter",

        introText:
            "collect points across the strike zone courses, unlock the bonus game, and win the daily grand prize.",

        howItWorks:
            "how does it work?",

        steps: [
            {
                number: "01",
                text:
                    "score 1500 points across the strike zone courses.",
            },
            {
                number: "02",
                text:
                    "hit the monster with the golden arrow.",
            },
            {
                number: "03",
                text:
                    "feed the monster and win the daily grand prize.",
            },
        ],

        prizeTitle:
            "win the grand prize",

        prizeIconsAlt:
            "Feed the Beast prize icons",

        gameImageAlt:
            "Feed the Beast course",
    },
};

export function FeedTheBeastContent({ showUnlockHeading = false }) {
    const {
        language,
    } =
        useLanguage();

    const text =
        translations[language] ||
        translations.hu;

    const GameHeading = showUnlockHeading ? "h3" : "h1";

    return (
        <>

            {/* FEED THE BEAST BEMUTATKOZÁS */}
            <section className="bg-[#dedede] text-black">
                <div className="mx-auto flex w-full max-w-[430px] flex-col items-center px-7 pb-16 pt-12 text-center md:max-w-5xl md:px-12 md:pb-24 md:pt-16">
                    {showUnlockHeading && (
                        <h2 className="mb-6 text-[clamp(1.75rem,6vw,3.5rem)] font-black uppercase leading-tight">
                            {language === "en" ? "REACHED 1,500 POINTS?" : "ELÉRTED AZ 1500 PONTOT?"}
                            <span className="mt-2 block">{language === "en" ? "UNLOCK THE..." : "MEGNYÍLIK A..."}</span>
                        </h2>
                    )}
                    {/* SZÖRNY IKON A KÜLÖNÁLLÓ OLDALON */}
                    {!showUnlockHeading && <div
                        className="flex shrink-0 items-center justify-center overflow-hidden rounded-full border-[3px] border-black"
                        style={{
                            width: "80px",
                            height: "80px",
                            minWidth: "80px",
                            maxWidth: "80px",
                            minHeight: "80px",
                            maxHeight: "80px",
                            boxSizing:
                                "border-box",
                        }}
                    >
                        <img
                            src="/v4/monster.png"
                            alt={
                                text.monsterAlt
                            }
                            className="h-[72px] w-[72px] object-contain"
                        />
                    </div>}

                    {/* LOGÓ */}
                    <img
                        src="/v4/feed-the-beast-logo-wobg.png"
                        alt="Feed the Beast"
                        className="mt-4 h-auto w-full max-w-[325px] object-contain md:mt-7 md:max-w-[520px]"
                    />

                    {/* BEVEZETŐ */}
                    <p className="mt-10 max-w-[320px] text-[20px] font-black lowercase leading-[1.15] md:mt-14 md:max-w-2xl md:text-[32px] md:leading-[1.2]">
                        {
                            text
                                .introTitleFirst
                        }

                        <br className="md:hidden" />{" "}

                        {
                            text
                                .introTitleSecond
                        }
                    </p>

                    <p className="mt-6 max-w-[320px] text-[15px] leading-[1.35] text-neutral-700 md:max-w-2xl md:text-[21px] md:leading-[1.5]">
                        {
                            text.introText
                        }
                    </p>

                    {/* LÉPÉSEK */}
                    <div className="mt-12 w-full max-w-3xl border-[3px] border-black bg-[#f2f2f2] md:mt-16">
                        <div className="bg-black px-6 py-7 text-white md:px-10 md:py-9">
                            <p className="text-[12px] font-black lowercase tracking-[0.18em] text-white/50 md:text-[14px]">
                                {
                                    text
                                        .howItWorks
                                }
                            </p>

                            <GameHeading className="mt-3 text-[24px] font-black lowercase leading-none md:text-[40px]">
                                feed the beast
                            </GameHeading>
                        </div>

                        <div className="px-5 py-3 md:px-10 md:py-5">
                            {text.steps.map(
                                (
                                    step,
                                    index
                                ) => (
                                    <div
                                        key={
                                            step.number
                                        }
                                        className={`flex items-center gap-4 py-5 text-left md:gap-7 md:py-7 ${
                                            index !==
                                            text
                                                .steps
                                                .length -
                                            1
                                                ? "border-b border-black/25"
                                                : ""
                                        }`}
                                    >
                                        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-black text-[11px] font-black text-white md:h-14 md:w-14 md:text-[14px]">
                                            {
                                                step.number
                                            }
                                        </span>

                                        <p className="text-[15px] font-semibold lowercase leading-[1.35] text-neutral-700 md:text-[21px] md:leading-[1.45]">
                                            {
                                                step.text
                                            }
                                        </p>
                                    </div>
                                )
                            )}
                        </div>
                    </div>

                    {/* NYEREMÉNYEK */}
                    <div className="mt-12 md:mt-16">
                        <p className="text-[12px] font-black lowercase tracking-[0.18em] text-neutral-500 md:text-[14px]">
                            {
                                text
                                    .prizeTitle
                            }
                        </p>

                        <img
                            src="/v4/monster-iconset.png"
                            alt={
                                text
                                    .prizeIconsAlt
                            }
                            className="mt-7 h-auto w-full max-w-[310px] object-contain md:mt-9 md:max-w-[440px]"
                        />
                    </div>
                </div>
            </section>

            {/* PÁLYA KÉPE */}
            <section className="relative w-full overflow-hidden bg-black">
                <div className="relative h-[310px] w-full overflow-hidden md:h-[700px]">
                    {/* BLUR HÁTTÉR */}
                    <img
                        src="/v4/feed_the_beast_strike.webp"
                        alt=""
                        aria-hidden="true"
                        className="absolute inset-0 h-full w-full scale-110 object-cover blur-2xl"
                    />

                    {/* SÖTÉTÍTÉS */}
                    <div
                        aria-hidden="true"
                        className="absolute inset-0 bg-black/25"
                    />

                    {/* EREDETI KÉP */}
                    <div className="relative z-10 mx-auto flex h-full w-full max-w-[1440px] items-center justify-center">
                        <img
                            src="/v4/feed_the_beast_strike.webp"
                            alt={
                                text
                                    .gameImageAlt
                            }
                            className="h-full w-full object-contain"
                        />
                    </div>
                </div>
            </section>

        </>
    );
}
export default function FeedTheBeastPage() {
    return (
        <main className="min-h-screen overflow-x-hidden bg-black font-sans">
            <Header />
            <FeedTheBeastContent />
            <Footer />
        </main>
    );
}
